import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import theme from './theme';
import Home from './pages/Home';
import ListGym from './pages/ListGym';
import GymList from './pages/GymList';
import GymDetails from './pages/GymDetails';
import Login from './pages/Login';
import Register from './pages/Register';
import MyListings from './pages/MyListings';
import Bookings from './pages/Bookings';
import ReceivedBookings from './pages/ReceivedBookings';
import { AuthProvider } from './context/AuthContext';
import Navigation from './components/Navigation';
import CreateListing from './pages/CreateListing';
import ListingDetails from './pages/ListingDetails';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import VerifyEmail from './pages/VerifyEmail';
import AuthSuccess from './pages/AuthSuccess';
import Payment from './pages/Payment';
import Earnings from './pages/Earnings';

function App() {
  // Force rebuild for environment variables
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <AuthProvider>
          <Router>
            <Navigation />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/gyms" element={<GymList />} />
              <Route path="/gyms/:id" element={<GymDetails />} />
              <Route path="/list-gym" element={<ListGym />} />
              <Route path="/my-listings" element={<MyListings />} />
              <Route path="/bookings" element={<Bookings />} />
              <Route path="/received-bookings" element={<ReceivedBookings />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/auth/success" element={<AuthSuccess />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/earnings" element={<Earnings />} />
              <Route path="/create-listing" element={<CreateListing />} />
              <Route path="/listing/:id" element={<ListingDetails />} />
            </Routes>
          </Router>
        </AuthProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
